import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForContestComponent extends Component {
  // Defaults
  availableFilters = [];
  defaultColumns = ['title', 'cmsModified', 'startDate', 'endDate'];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'title',
      isMainColumn: true,
    },
    {
      property: 'startDate',
      sortable: true,
      type: 'date',
      format: 'L LT',
    },
    {
      property: 'endDate',
      sortable: true,
      type: 'date',
      format: 'L LT',
    },
    {
      property: 'cmsLanguageId',
      type: 'translate-value',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
